export default (path: string) => path.replace(/^media/, 'uploads/hjp')